import en from './en';

export const homeTranslations: NamespaceTranslations<keyof typeof en> = {
  en,
};
